var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bt_edit",
    transform: "translate(-910 -314)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2133",
    "data-name": "Rectangle 2133",
    width: 33,
    height: 33,
    rx: 3,
    transform: "translate(910 314)",
    fill: "#13931c",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531",
    transform: "translate(866 145.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9971",
    "data-name": "Path 9971",
    d: "M52,272.753c.1-.366.2-.73.294-1.1.248-.985.489-1.972.74-2.956a.64.64,0,0,1,.16-.28q4.593-4.6,9.193-9.2c.031-.031.064-.06.082-.077l3.636,3.636c-.016.017-.054.061-.095.1q-4.575,4.574-9.153,9.145a.767.767,0,0,1-.335.193c-1.321.337-2.645.665-3.968,1a.763.763,0,0,0-.091.035h-.2L52,272.985Z",
    transform: "translate(0 -80.245)",
    fill: "#00931c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9972",
    "data-name": "Path 9972",
    d: "M52,659.2l.265.265H52Z",
    transform: "translate(0 -466.456)",
    fill: "#00931c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9973",
    "data-name": "Path 9973",
    d: "M390.251,181.431l-3.6-3.6c.447-.458.878-.951,1.363-1.385a1.828,1.828,0,0,1,2.352.008,15.375,15.375,0,0,1,1.266,1.266,1.78,1.78,0,0,1-.006,2.355C391.192,180.553,390.708,180.985,390.251,181.431Z",
    transform: "translate(-323.075)",
    fill: "#00931c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.9f86fe71cb6e4975c28bb6a1e3573b66.svg";
export { ForwardRef as ReactComponent };